import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import { Eye, TrendingUp, TrendingDown } from "lucide-react";

const DAY_FR = { mon: "Lun", tue: "Mar", wed: "Mer", thu: "Jeu", fri: "Ven", sat: "Sam", sun: "Dim" };

/** 7-day profile views sparkline — shared by talent & creator dashboards. */
export default function ViewsChart({ chart = [], total = 0, week = 0, trend = 0, subtitle }) {
  const data = chart.map((d) => ({ ...d, label: DAY_FR[d.label] || d.label }));
  const up = trend >= 0;
  return (
    <div className="rounded-3xl bg-white border border-[#EADDC9] p-6 sm:p-7 flex flex-col" data-testid="views-chart-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="caption-label text-[#A26F3E]">Vues du profil</p>
          <div className="flex items-baseline gap-2 mt-1">
            <span className="font-serif text-4xl text-[#1A1A1A] leading-none" data-testid="views-week-total">{week}</span>
            <span className="text-xs text-[#8B8680]">cette semaine</span>
          </div>
        </div>
        <div className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ${up ? "bg-[#E7F5EC] text-[#2E7D32]" : "bg-red-50 text-[#A3483F]"}`} data-testid="views-trend">
          {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
          {up ? "+" : ""}{trend}%
        </div>
      </div>
      <div className="h-28 mt-4 -mx-2">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 4, right: 8, left: 8, bottom: 0 }}>
            <defs>
              <linearGradient id="viewsFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#C68E59" stopOpacity={0.45} />
                <stop offset="100%" stopColor="#C68E59" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: "#8B8680" }} axisLine={false} tickLine={false} />
            <Tooltip
              cursor={{ stroke: "#EADDC9" }}
              contentStyle={{ borderRadius: 12, border: "1px solid #EADDC9", fontSize: 12 }}
              formatter={(v) => [`${v} vue${v > 1 ? "s" : ""}`, ""]}
            />
            <Area type="monotone" dataKey="views" stroke="#C68E59" strokeWidth={2} fill="url(#viewsFill)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <p className="text-xs text-[#8B8680] mt-3 inline-flex items-center gap-1.5">
        <Eye className="w-3.5 h-3.5" /> {total} vue{total > 1 ? "s" : ""} au total{subtitle ? ` · ${subtitle}` : ""}
      </p>
    </div>
  );
}
